export const EVALUATOR_TYPE_LIST = Object.freeze([
	{
		id: 1,
		label: "Deducción",
	},
	{
		id: 2,
		label: "Percepción",
	},
])
